module.exports = __webpack_public_path__ + "img/hylei-5.a182a145.png";